import React, { useEffect, useState, CSSProperties } from 'react';
import classNames from 'classnames';
import { InputNumber } from 'antd';
import _noop from 'lodash/noop';

import './label-number-keyboard-input.scss';

interface Props {
	label?: string;
	minValue?: number;
	maxValue?: number;
	defaultValue?: number;
	onChange?: (value: number) => void;
	value?: number;
	disabled?: boolean;
	style?: CSSProperties;
	className?: string;
}

const LabelNumberKeyboardInput: React.FC<Props> = ({
	label,
	maxValue = Infinity,
	minValue = -Infinity,
	defaultValue,
	onChange = _noop,
	value,
	disabled = false,
	style,
	className
}) => {
	const [componentValue, setComponentValue] = useState<number>(value || defaultValue || 0);

	useEffect(() => {
		if (value !== undefined) {
			setComponentValue(value || 0);
		}
	}, [value]);

	const handleChangeValue = (newValue: number) => {
		if (!Number.isInteger(newValue) || disabled) return;
		const valueToUpdate = newValue < minValue ? minValue : newValue > maxValue ? maxValue : newValue;
		if (value === undefined) {
			setComponentValue(valueToUpdate);
		}

		onChange(valueToUpdate);
	};

	return (
		<div className={classNames('label-number-keyboard-input', className)} style={style}>
			<InputNumber
				className="input-number"
				value={componentValue}
				onChange={handleChangeValue}
				type="number"
				min={minValue}
				max={maxValue}
				step={1}
				disabled={disabled}
			/>
			<div className="container-label-text">
				<div className="label-text">{label}</div>
			</div>
		</div>
	);
};

export default LabelNumberKeyboardInput;
